const ID_TOKEN_KEY = 'id_token'
const REFRESH_TOKEN_KEY = 'refresh_token'
const USER_INFO = 'user_info'
const HOST = window.location.hostname

export const getToken = () => {
  return get(ID_TOKEN_KEY, false)
}

export const getRefreshToken = () => {
  let cookies = document.cookie
  let cookiesArray = cookies.split('; ')
  let value
  for (var c of cookiesArray) {
    var cArray = c.split('=')
    if (cArray[0] === REFRESH_TOKEN_KEY) {
        value = cArray[1]
    }
  }
  return value
}

export const saveToken = (token) => {
  save(ID_TOKEN_KEY, token, false)
}

export const saveRefreshToken = (token) => {
  // リフレッシュトークンは、有効期限を指定して保存する。
  const maxAgeSec = process.env.VUE_APP_REFRESH_TOKEN_EXPIRE_SEC
  document.cookie = REFRESH_TOKEN_KEY + '=' + token + ';path=/;max-age=' + maxAgeSec + ';SameSite=Lax;'
}

const decodeJwtPayload = (token) => {
  const base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')
  const padded = base64.padEnd(base64.length + (4 - base64.length % 4) % 4, '=')
  const decoded = decodeURIComponent(
    atob(padded)
      .split('')
      .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
      .join('')
  )
  return JSON.parse(decoded)
}

// Reads the `sessionFlag` claim directly off the id token. The JWT is a signed-only JWS, not
// encrypted, and the cookie holding it is already non-HttpOnly and readable by app JS, so
// decoding it client-side adds no new exposure. Signature verification is intentionally
// skipped here: this value only drives frontend routing UX, never an authorization decision -
// that enforcement happens server-side regardless of what this returns.
export const getSessionFlag = () => {
  const token = getToken()
  if (!token) {
    return null
  }
  try {
    return decodeJwtPayload(token).sessionFlag
  } catch (e) {
    return null
  }
}

// 本人確認画面(Standard Mode)がDBを介さずJWTペイロードのみからlogin_idを読み取り専用表示する
// ために使用する。getSessionFlagと同じ理由でsignatureは検証しない - フロントのUX表示にのみ
// 使用し、認可判断はサーバー側のAuthorizationFilterが行う。
export const getLoginId = () => {
  const token = getToken()
  if (!token) {
    return null
  }
  try {
    return decodeJwtPayload(token).loginId
  } catch (e) {
    return null
  }
}

export const getUser = () => {
  return get(USER_INFO, true)
}

export const saveUser = (user) => {
  save(USER_INFO, user, true)
}

// Internal only - every consumer imports the default export object below, never this (or
// save/getKey) by name.
const get = (key, isObject) => {
  if (key !== ID_TOKEN_KEY) {
      let value = window.localStorage.getItem(getKey(key))
      if (isObject) value = parseStoredJson(value)
      return value
  } else {
      let cookies = document.cookie
      let cookiesArray = cookies.split('; ')
      let value
      for (var c of cookiesArray) {
        var cArray = c.split('=')
        if (cArray[0] === ID_TOKEN_KEY) {
            value = cArray[1]
        }
      }
      if (isObject) value = parseStoredJson(value)
      return value
  }
}

// A corrupted/malformed stored value (e.g. the literal string "undefined") must never crash
// JSON.parse uncaught here - getUser() is read on every route navigation, so an uncaught
// exception here would break the router guard for every subsequent navigation. Returns null
// (not undefined) on failure so CHECK_AUTH_CLIENT's `user !== null` check treats corrupted
// storage the same as "nothing stored" and self-heals via PURGE_AUTH_CLIENT.
const parseStoredJson = (value) => {
  try {
    return JSON.parse(value)
  } catch (e) {
    return null
  }
}

const save = (key, value, isObject) => {
  if (isObject) {
    value = JSON.stringify(value)
    // JSON.stringify(undefined) returns the JS value undefined, not a string - writing that
    // via localStorage.setItem would coerce it to the literal string "undefined", which a
    // later JSON.parse can't handle. Treat "nothing serializable" as "nothing to save":
    // clear the key entirely instead, so a later get() returns null like an untouched key would.
    if (value === undefined) {
      if (key === ID_TOKEN_KEY) {
        document.cookie = ID_TOKEN_KEY + '=;path=/;max-age=0'
      } else {
        window.localStorage.removeItem(getKey(key))
      }
      return
    }
  }
  if (key === ID_TOKEN_KEY) {
     document.cookie = ID_TOKEN_KEY + '=' + value + ';path=/;SameSite=Lax;'
  } else {
     window.localStorage.setItem(getKey(key), value)
  }
}

const getKey = (key) => {
  return HOST + '.' + key
}

export const destroyAll = () => {
  let cookies = document.cookie
  let cookiesArray = cookies.split('; ')
  for (var c of cookiesArray) {
        var cArray = c.split('=')
        // アクセストークンとリフレッシュトークンを削除。
        // 両方とも save()/saveRefreshToken() で path=/ を指定して設定されるため、削除時も
        // 同じ path=/ を指定する必要がある(RFC 6265: 一致しないと別のcookieとして扱われ、
        // 本物のcookieは削除されない)。
        if (cArray[0] === ID_TOKEN_KEY || cArray[0] === REFRESH_TOKEN_KEY) {
            document.cookie = cArray[0] + '=;path=/;max-age=0'
        }
  }

  return window.localStorage.clear()
}

export const saveCookie = (name, value, days, isObject = true) => {
  let expires = ''
  if (isObject) {
    value = JSON.stringify(value)
  }
  if (days) {
    let date = new Date()
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000))
    expires = '; expires=' + date.toUTCString()
  } else {
    // very long expire
    let date = new Date('2050-01-01')
    expires = '; expires=' + date.toUTCString()
  }
  document.cookie = name + '=' + (value || '') + expires + '; path=/'
}

export const getCookie = (name, isObject = true) => {
  let cookiesArray = document.cookie.split('; ')
  for (let c of cookiesArray) {
    let cArray = c.split('=')
    if (cArray[0] === name) {
      // Same defensive reasoning as parseStoredJson above - a malformed cookie value must
      // never throw uncaught here.
      return isObject ? parseStoredJson(cArray[1]) : cArray[1]
    }
  }
  return null
}

export default {
  getToken,
  getRefreshToken,
  saveToken,
  saveRefreshToken,
  getSessionFlag,
  getLoginId,
  getUser,
  saveUser,
  destroyAll,
  saveCookie,
  getCookie
}
